import React, { useCallback, useMemo } from "react";

import { useIntl } from "react-intl";

import DistanceUnit from "@mapmycustomers/shared/enum/DistanceUnit";
import { Labeled, SelectField } from "@mapmycustomers/ui";

import useAnalytics from "@app/util/contexts/useAnalytics";
import { getDistanceUnitDisplayName } from "@app/util/ui";

interface Props {
  className?: string;
  label?: string;
  onChange?: (unit: DistanceUnit) => void;
  value?: DistanceUnit;
}

const DistanceUnitSelect: React.FC<Props> = ({ className, label, onChange, value }) => {
  const intl = useIntl();
  const analyticIssuer = useAnalytics();
  const options = useMemo(
    () =>
      Object.values(DistanceUnit).map((unit) => ({
        label: getDistanceUnitDisplayName(intl, unit),
        value: unit,
      })),
    [intl]
  );

  const handleChange = useCallback(
    (unit: DistanceUnit) => {
      analyticIssuer?.clicked(["Default Org Distance"], { distance: unit });
      onChange?.(unit);
    },
    [analyticIssuer, onChange]
  );

  return (
    <Labeled label={label}>
      <SelectField
        className={className}
        dropdownMatchSelectWidth={false}
        onChange={handleChange}
        options={options}
        value={value}
      />
    </Labeled>
  );
};

export default DistanceUnitSelect;
